import React from "react";
import { Box, Typography } from "@mui/material";
import type { SxProps, Theme } from "@mui/system";
import { Link as RouterLink } from "react-router-dom";
import { motion } from "framer-motion";
// ⬇️ Update this import to your actual asset location
import StageMark from "../../components/assets/brand/StageLink_logo_white.png"; // fallback icon

type StageLinkLogoProps = {
  withIcon?: boolean;
  iconSrc?: string;
  iconAlt?: string;
  size?: "xs" | "sm" | "md" | "lg" | "xl";
  tm?: boolean;
  to?: string;
  onClick?: () => void;
  stageColor?: string;
  linkGradient?: string;
  gap?: number | string;
  sx?: SxProps<Theme>;
};

/** — Netflix-ish tokens (design only) — */
const COLORS = {
  bg: "#0b0b0b",
  panel: "#141414",
  border: "rgba(255,255,255,0.12)",
  text: "#ffffff",
  textMuted: "rgba(255,255,255,0.75)",
  red: "#E50914",
  redHover: "#b20710",
};

export const StageLinkLogo: React.FC<StageLinkLogoProps> = ({
  withIcon = true,
  iconSrc = StageMark,
  iconAlt = "StageLink mark",
  size = "md",
  tm = true,
  to,
  onClick,
  stageColor = "#FFFFFF",
  linkGradient = "linear-gradient(90deg, #E50914, #b20710)",
  gap = 0.75,
  sx,
}) => {
  const fontSizes = { xs: 18, sm: 22, md: 28, lg: 34, xl: 44 } as const;
  const fs = fontSizes[size];

  const Wrapper: any = to ? RouterLink : Box;

  return (
    <Wrapper
      to={to as any}
      onClick={onClick}
      style={{ textDecoration: "none" }}
      aria-label="StageLink"
    >
      <Box
        sx={{
          display: "inline-flex",
          flexDirection: "column",          // ⬅️ vertical stack
          alignItems: "center",             // centered & elegant
          gap,
          ...sx,
        }}
      >
        {withIcon && iconSrc && (
          <Box
            component="img"
            src={iconSrc}
            alt={iconAlt}
            sx={{
              height: fs * 1.2,              // responsive logo height
              width: "auto",
              display: "block",
            }}
          />
        )}

        {/* Tagline directly BELOW the logo, responsive & modern */}
        {/* <Typography
          component={motion.div}
          initial={{ opacity: 0, y: 8 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.2 }}
          sx={(theme) => ({
            textAlign: "center",
            lineHeight: 1.25,
            // responsive font sizes tuned to logo size
            fontWeight: 800,
            fontFamily: "Lexend, sans-serif",
            fontSize: {
              xs: Math.max(12, fs * 0.48),
              sm: Math.max(13, fs * 0.54),
              md: Math.max(14, fs * 0.6),
              lg: Math.max(15, fs * 0.64),
              xl: Math.max(16, fs * 0.68),
            },
            mt: 0.75,
            color: COLORS.text,
          })}
        >
          <Box component="span" sx={{ color: COLORS.red }}>
            The Real-Time Infrastructure
          </Box>
          <br />
          <Box component="span" sx={{ color: COLORS.textMuted }}>
            For Global Audience Engagement.
          </Box>
        </Typography> */}
      </Box>
    </Wrapper>
  );
};
